var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkOtbShift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64503_46621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1176 10V6.40825C23.1176 5.7799 22.868 5.17729 22.4237 4.73298C21.9794 4.28867 21.3767 4.03906 20.7484 4.03906L19.5 4M8.88043 25.3618H6.53325C5.9049 25.3618 5.30229 25.1122 4.85798 24.6679C4.41367 24.2235 4.16406 23.6209 4.16406 22.9926V6.40825C4.16406 5.7799 4.41367 5.17729 4.85798 4.73298C5.30229 4.28867 5.9049 4.03906 6.53325 4.03906L8.5 4",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1176 18V12.4083C28.1176 11.7799 27.868 11.1773 27.4237 10.733C26.9794 10.2887 26.3767 10.0391 25.7484 10.0391H13.9024H11.5333C10.9049 10.0391 10.3023 10.2887 9.85798 10.733C9.41367 11.1773 9.16406 11.7799 9.16406 12.4083V28.9926C9.16406 29.6209 9.41367 30.2235 9.85798 30.6679C10.3023 31.1122 10.9049 31.3618 11.5333 31.3618H13.9024",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1094 20.0078V21.3221",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6328 20.0078C25.6328 21.088 25.6328 21.1147 25.6328 21.1147",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7041 21.2891H18.0236C17.2598 21.2891 16.6406 21.9082 16.6406 22.672V31.6447C16.6406 32.4085 17.2598 33.0277 18.0236 33.0277H27.7041C28.4679 33.0277 29.0871 32.4085 29.0871 31.6447V22.672C29.0871 21.9082 28.4679 21.2891 27.7041 21.2891Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5117 24.5429L19.8466 30.2084M25.5117 24.5429L23.4647 24.5429L22.4412 24.5429M25.5117 24.5429L25.5117 26.5899L25.5117 27.6133",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.7656L16.5 13.7656",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.7656H16.5",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 1.92969H9.75219C9.03905 1.92969 8.46094 2.36173 8.46094 2.89469V4.82469C8.46094 5.35764 9.03905 5.78969 9.75219 5.78969H17.4997C18.2128 5.78969 18.7909 5.35764 18.7909 4.82469V2.89469C18.7909 2.36173 18.2128 1.92969 17.4997 1.92969Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64503_46621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkOtbShift);
export default __webpack_public_path__ + "static/media/bulkOtbShift.19a573413e8cda91a88c196371ebbc98.svg";
export { ForwardRef as ReactComponent };